import { initializeApp } from "firebase/app";
import {
  getFirestore,
  collection,
  collectionGroup,
  initializeFirestore,
  enableMultiTabIndexedDbPersistence,
  // persistentLocalCache,
  // persistentMultipleTabManager,
} from "firebase/firestore";

import {
  createUserWithEmailAndPassword,
  getAuth,
  GoogleAuthProvider,
  signInWithEmailAndPassword,
  signInWithPopup,
  signOut,
} from "firebase/auth";

// Config can't be kept private. Security rules have been set up to restrict access.

let config = null;

if (import.meta.env.MODE === "development" || import.meta.env.MODE === "test") {
  config = {
    apiKey: "AIzaSyBmGtaSdrMB_HAtwPFEMcA5mxLFQ36ddOI",
    authDomain: "lrng-hooks.firebaseapp.com",
    databaseURL: "https://lrng-hooks.firebaseio.com",
    projectId: "lrng-hooks",
    storageBucket: "lrng-hooks.appspot.com",
    messagingSenderId: "942485656154",
    appId: "1:942485656154:web:83c4184ec01a9014d13e63",
  };
}

if (import.meta.env.MODE === "production") {
  config = {
    apiKey: "AIzaSyAoRFcnEwdRMhclZ7efkZjAVcz9vZGeW7g",
    authDomain: "hes-web-production.firebaseapp.com",
    databaseURL: "https://hes-web-production.firebaseio.com",
    projectId: "hes-web-production",
    storageBucket: "hes-web-production.appspot.com",
    messagingSenderId: "761624787214",
    appId: "1:761624787214:web:2993c192bca56aa542bf5f",
  };
}

const firebase = initializeApp(config);

// Old way without multitab persistence >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
const firestore = getFirestore(firebase);
// <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<
// console.log("initia", initializeFirestore());
// Deprecated way with multitab persistence >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
// const firestore = initializeFirestore(firebase, {});
enableMultiTabIndexedDbPersistence(firestore);
// <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<

// Proper way to do mutitab persistence but some imports not working yet >>>>
// export const firestore = initializeFirestore(firebase, {
//   localCache: persistentLocalCache({
//     tabManager: persistentMultipleTabManager(),
//   }),
// });
// <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<

export const usersRef = collection(firestore, "users");
export const timesheetsRef = collection(firestore, "timesheets");
export const jobsheetsRef = collection(firestore, "jobsheets");
export const restoresRef = collection(firestore, "restores");
export const quotesRef = collection(firestore, "quotes");
export const ratesRef = collection(firestore, "rates");
export const operativesRef = collection(firestore, "operatives");
export const settingsRef = collection(firestore, "settings");
export const customersRef = collection(firestore, "customers");
export const todosRef = collection(firestore, "todos");
export const templatesRef = collection(firestore, "templates");
export const jobDescsRef = collectionGroup(firestore, "jobDescriptions");

//firestore.settings({ timestampsInSnapshots: true });

if (import.meta.env.MODE === "test") {
  // console.log("browser", browserLocalPersistence);
}

export const auth = getAuth(firebase);

const provider = new GoogleAuthProvider();
provider.addScope("email");
provider.addScope("profile");

export const signInGoogle = () => signInWithPopup(auth, provider);

export const signUpWithEmail = (email, password) => {
  return createUserWithEmailAndPassword(auth, email, password);
};

export const signInWithEmail = (email, password) => {
  return signInWithEmailAndPassword(auth, email, password);
};

//   .catch(function (error) {
//   // Handle Errors here.
//   var errorCode = error.code;
//   var errorMessage = error.message;
//   // ...
// });

// auth.getRedirectResult().then(function (result) {
//   console.log("Redirect result ", result);
// });

export const signOff = () => signOut(auth);

export default firebase;
